var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      class: ["pop-overlay", "alert", _vm.theme]
    },
    [
      _c(
        "div",
        { staticClass: "pop-alert", style: { width: _vm.width + "px" } },
        [
          _c("div", { staticClass: "pop-title" }, [
            _c("h5", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("span", {
              staticClass: "icon-close",
              on: { click: _vm._onHide }
            })
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "pop-inner",
            domProps: { innerHTML: _vm._s(_vm.content) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "btn-box" }, [
            _c("div", { staticClass: "ui layout" }, [
              _c("div", { staticClass: "row-1" }, [
                _c(
                  "button",
                  { staticClass: "btn", on: { click: _vm._onConfirm } },
                  [_vm._v(_vm._s(_vm.confirmText))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-1" }, [
                _c(
                  "button",
                  { staticClass: "btn", on: { click: _vm._onCancel } },
                  [_vm._v(_vm._s(_vm.cancelText))]
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68167b00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68167b00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alertPlugin/confirm.vue
// module id = null
// module chunks = 